import "./index.scss"
function Qualification() {
  const list = [
    {
      id: 1,
      title: "国家高新技术企业",
      img: require("../../../../assets/qualification1.png")
    },
    {
      id: 2,
      title: "上海市创新型中小企业",
      img: require("../../../../assets/qualification2.png")
    },
    {
      id: 3,
      title: "AAA级企业信用等级",
      img: require("../../../../assets/qualification3.png")
    },
    {
      id: 4,
      title: "AAA级质量服务诚信",
      img: require("../../../../assets/qualification4.png")
    },
    {
      id: 5,
      title: "三级等级保护资质",
      img: require("../../../../assets/qualification5.png")
    },
    {
      id: 6,
      title: "电信业务经营许可证",
      img: require("../../../../assets/qualification6.png")
    },
    {
      id: 7,
      title: "软件著作权35个",
      img: require("../../../../assets/qualification7.png")
    },
    {
      id: 8,
      title: "产品相关专利2个",
      img: require("../../../../assets/qualification8.png")
    },
    {
      id: 9,
      title: "中国拍卖行业协会会员单位",
      img: require("../../../../assets/qualification9.png")
    },
    {
      id: 10,
      title: "广东省破产管理人协会会员",
      img: require("../../../../assets/qualification10.png")
    },
    {
      id: 11,
      title: "十二届财经峰会最具投资价值企业",
      img: require("../../../../assets/qualification11.png")
    },
    {
      id: 12,
      title: "上海市宁波商会副会长单位",
      img: require("../../../../assets/qualification12.png")
    },
  ]
  return (
    <div className="qualification-container">
      <div className="subtitle">企业资质</div>
      <div className="title">ENTERPRISE QUALIFICATION</div>
      <div className="qualification-info">
        {list.map((item, index) => {
          return (
            <div key={index} className="list-item">
              <div className="img-box">
                <img className="img" src={item.img}></img>
              </div>
              <div className="title-row">
                {item.title}
              </div>


            </div>
          )
        })}


      </div>

    </div>
  )
}
export default Qualification